/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '@ng-bootstrap/ng-bootstrap/alert/alert';
import * as i3 from '@ng-bootstrap/ng-bootstrap/alert/alert-config';
const styles_NgbAlert:any[] = ([] as any[]);
export const RenderType_NgbAlert:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_NgbAlert,
    data:{}});
function View_NgbAlert_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),4,'button',[['aria-label',
      'Close'],['class','close'],['type','button']],(null as any),[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.closeHandler()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n            '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',[['aria-hidden','true']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['×'])),(_l()(),i0.ɵted((null as any),['\n      ']))],
      (null as any),(null as any));
}
export function View_NgbAlert_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(2,[(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),6,'div',[['role','alert']],[[8,'className',0]],(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),
      i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NgbAlert_1)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n      '])),i0.ɵncd((null as any),
          0),(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵted((null as any),
          ['\n    ']))],(_ck,_v) => {
    var _co:i2.NgbAlert = _v.component;
    const currVal_1:any = _co.dismissible;
    _ck(_v,4,0,currVal_1);
  },(_ck,_v) => {
    var _co:i2.NgbAlert = _v.component;
    const currVal_0:any = (('alert alert-' + _co.type) + (_co.dismissible? ' alert-dismissible': ''));
    _ck(_v,1,0,currVal_0);
  });
}
export function View_NgbAlert_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'ngb-alert',([] as any[]),
      (null as any),(null as any),(null as any),View_NgbAlert_0,RenderType_NgbAlert)),
      i0.ɵdid(49152,(null as any),0,i2.NgbAlert,[i3.NgbAlertConfig],(null as any),
          (null as any))],(null as any),(null as any));
}
export const NgbAlertNgFactory:i0.ComponentFactory<i2.NgbAlert> = i0.ɵccf('ngb-alert',
    i2.NgbAlert,View_NgbAlert_Host_0,{dismissible:'dismissible',type:'type'},{close:'close'},
    ['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9saWIvamVua2lucy93b3Jrc3BhY2UvdmVueW91LXN0cmlwZS9ub2RlX21vZHVsZXMvQG5nLWJvb3RzdHJhcC9uZy1ib290c3RyYXAvYWxlcnQvYWxlcnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL2xpYi9qZW5raW5zL3dvcmtzcGFjZS92ZW55b3Utc3RyaXBlL25vZGVfbW9kdWxlcy9AbmctYm9vdHN0cmFwL25nLWJvb3RzdHJhcC9hbGVydC9hbGVydC5kLnRzIiwibmc6Ly8vdmFyL2xpYi9qZW5raW5zL3dvcmtzcGFjZS92ZW55b3Utc3RyaXBlL25vZGVfbW9kdWxlcy9AbmctYm9vdHN0cmFwL25nLWJvb3RzdHJhcC9hbGVydC9hbGVydC5kLnRzLk5nYkFsZXJ0Lmh0bWwiLCJuZzovLy92YXIvbGliL2plbmtpbnMvd29ya3NwYWNlL3ZlbnlvdS1zdHJpcGUvbm9kZV9tb2R1bGVzL0BuZy1ib290c3RyYXAvbmctYm9vdHN0cmFwL2FsZXJ0L2FsZXJ0LmQudHMuTmdiQWxlcnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCJcbiAgICA8ZGl2IFtjbGFzc109XCInYWxlcnQgYWxlcnQtJyArIHR5cGUgKyAoZGlzbWlzc2libGUgPyAnIGFsZXJ0LWRpc21pc3NpYmxlJyA6ICcnKVwiIHJvbGU9XCJhbGVydFwiPlxuICAgICAgPGJ1dHRvbiAqbmdJZj1cImRpc21pc3NpYmxlXCIgdHlwZT1cImJ1dHRvblwiIGNsYXNzPVwiY2xvc2VcIiBhcmlhLWxhYmVsPVwiQ2xvc2VcIiAoY2xpY2spPVwiY2xvc2VIYW5kbGVyKClcIj5cbiAgICAgICAgICAgIDxzcGFuIGFyaWEtaGlkZGVuPVwidHJ1ZVwiPiZ0aW1lczs8L3NwYW4+XG4gICAgICA8L2J1dHRvbj5cbiAgICAgIDxuZy1jb250ZW50PjwvbmctY29udGVudD5cbiAgICA8L2Rpdj5cbiAgICAiLCI8bmdiLWFsZXJ0PjwvbmdiLWFsZXJ0PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDRU07TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUEyRTtNQUFBO01BQUE7SUFBQTtJQUEzRTtFQUFBLGdDQUFvRztNQUM5RjtVQUFBO01BQXlCLHNDQUFjOzs7O29CQUhuRCwyQ0FDSTtNQUFBO01BQUEsOEJBQThGLDZDQUM1RjthQUFBO2FBQUE7VUFBQSx3QkFFUyxvREFDVDtVQUFBLEdBQXlCLDJDQUNyQjtVQUFBOztJQUpJO0lBQVIsV0FBUSxTQUFSOzs7SUFERztJQUFMLFdBQUssU0FBTDs7OztvQkNESjtNQUFBO2FBQUE7VUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/venyou-stripe/src/$$_gendir/~/@ng-bootstrap/ng-bootstrap/alert/alert.ngfactory.ts